import { render, staticRenderFns } from "./AddEdit.vue?vue&type=template&id=24ed7b7c&scoped=true"
import script from "./AddEdit.vue?vue&type=script&lang=js"
export * from "./AddEdit.vue?vue&type=script&lang=js"
import style0 from "./AddEdit.vue?vue&type=style&index=0&id=24ed7b7c&prod&lang=scss&scoped=true"
import style1 from "./AddEdit.vue?vue&type=style&index=1&id=24ed7b7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed7b7c",
  null
  
)

export default component.exports